import {
  whenBuilder as cssWhenBuilder,
  switchBuild as cssSwitchBuild,
  varBuilder as cssVarBuilder,
} from './cssBuilder'
import {
  whenBuilder as docWhenBuilder,
  switchBuild as docSwitchBuild,
  varBuilder as docVarBuilder,
} from './docBuilder'

export const composeStyle = {
  when: cssWhenBuilder,
  switch: cssSwitchBuild,
  var: cssVarBuilder,
}

export const composeInDoc = {
  when: docWhenBuilder,
  switch: docSwitchBuild,
  var: docVarBuilder,
}
